export default "__VITE_ASSET__DlFx98bD__"